<script setup>
import ViewPortHeader from './SimpliaV2Components/ViewportHeader/ViewportHeader.vue';
//import ViewPortHeader from './SimpliaV2Components/NewMessageBox/NewMessageBox.vue';

defineProps({
    PanelTitle: {
      type: String,
      required: true
    },
    ClientID: {
      type: String,
      required: true
    },
    viewportID: {
      type: String,
      required: true
    }

});

let emit = defineEmits(['desk-mode-toggled']);

function deskModeToggled(viewportID, val) {
  emit('desk-mode-toggled', viewportID, val);
}

</script>



<template>
<ViewPortHeader v-on:desk-mode-toggled="deskModeToggled" :viewportID="viewportID" :ClientID="ClientID"></ViewPortHeader>

</template>
